import React, { useState, useEffect } from "react";
import { Form, Row, Col, Modal, Button, Container } from "react-bootstrap";
import ApiService from "../../../ApiService";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Typography } from "@material-ui/core";
import { Card } from "react-bootstrap";
import { getSingle } from "../../../strapi";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ButtonGroup() {
  return (
    <div className="button-group">
      <button className="button-group-bttn">Positive</button>
      <button className="button-group-bttn">Negative</button>
    </div>
  );
}

const getCmsData = async () => {
  const content = await getSingle("clinician-portal", {
    populate: {
      negativeTemplates: {
        populate: "*"
      }
    }
  });
  return {
    revalidate: 10,
    data: content
  };
};

const SendResult = props => {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [cmsData, setCmsData] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState({
    title: "",
    id: null
  });
  const [testType, setTestType] = useState([]);
  const [selectedTemplateMessage, setSelectedTemplateMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCmsData().then(res => {
      setCmsData(res?.data?.negativeTemplates);
    });
  }, []);

  const handleSnackClose = () => {
    setSnackOpen(false);
  };
  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const sendMessage = async () => {
    try {
      const r = await ApiService.postPatientMessage({
        kitId: props.kit,
        message: selectedTemplateMessage
      });
      if (r.status === 200) {
        handleSnackOpen("Message Sent", "success");
      }
    } catch (error) {
      console.error(error);
      handleSnackOpen(error.message, "error");
    }
  };
  const handleChangeTest = e => {
    const selectedType = testType?.find(item => item?.name === e.target.value);
    const clinicianName = props.clinician?.firstName + " " + props.clinician?.lastName;
    const patientName = props.patient.name;
    if (!patientName) {
      window.confirm("There was an error fetching Patient's Name Automatically, please go ahead and manually enter patient name in the message.");
    }
    if (!clinicianName) {
      window.confirm(
        "We noticed you haven't entered your name in Profile Details. Please make sure to fill your details in Profile Page or please manually enter your name/signature in the message."
      );
    }

    let message = selectedType?.content?.replace(/{{patientName}}/g, patientName);
    message = message?.replace(/{{clinicianName}}/g, clinicianName);

    setSelectedTemplateMessage(message);
  };

  function submitNotes(noteType, notes, releaseNote = false) {
    if (!releaseNote) {
      async function putTestResultNotes() {
        try {
          setLoading(true);
          // eslint-disable-next-line no-unused-vars
          const putTestResultNotes = await ApiService.putTestResultNotes(props.kit, {
            noteType: noteType,
            notes: notes
          })
            .then(res => {
              handleSnackOpen("Draft Saved!", "success");
            })
            .catch(error => {
              const msg = error?.response?.data?.message ?? error?.message;
              handleSnackOpen(msg, "error");
            });
        } catch (err) {
          const msg = err?.response?.data?.message ?? err?.message;
          console.error(err);
          handleSnackOpen(msg, "error");
        } finally {
          setLoading(false);
        }
      }

      putTestResultNotes();
    } else {
      async function putTestResultNotes() {
        try {
          // eslint-disable-next-line no-unused-vars
          const putTestResultNotes = await ApiService.putTestResultNotes(props.kit, {
            noteType: noteType,
            notes: notes
          })
            .then(res => {
              handleSnackOpen("Draft Saved!", "success");
            })
            .catch(error => {
              const msg = error?.response?.data?.message ?? error?.message;
              handleSnackOpen(msg, "error");
            });

          async function putTestResultNotesRelease() {
            try {
              // eslint-disable-next-line no-unused-vars
              const putTestResultNotesRelease = await ApiService.putTestResultNotesRelease(props.kit)
                .then(res => {
                  handleSnackOpen("Send Successfully", "success");
                })
                .catch(error => {
                  const msg = error?.response?.data?.message ?? error?.message;
                  handleSnackOpen(msg, "error");
                });
            } catch (err) {
              const msg = err?.response?.data?.message ?? err?.message;
              console.error(err);
              handleSnackOpen(msg, "error");
            }
          }
          putTestResultNotesRelease();
        } catch (err) {
          console.error(err);
          handleSnackOpen(err.message, "error");
        }
      }

      putTestResultNotes();
    }
  }

  return (
    <Modal size="xl" show={props.showSendMsgModal} onHide={() => props.closeSendMsgModal} backdrop={"static"}>
      <Modal.Header id="ModalTitle">
        <Modal.Title>Send Result</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} md={12} lg={12}>
            <Row className="patient-info">
              <Col xs={12} md={4}>
                <Row>
                  <Typography variant="body1">Name {props.patient.name}</Typography>
                </Row>
                <Row>
                  <Typography variant="body1">Phone {props.patient.phoneNumber}</Typography>
                </Row>
              </Col>
              <Col xs={12} md={4}>
                <Row>
                  <Typography variant="body1">DOB {props.patient.dob}</Typography>
                </Row>
                <Row>
                  <Typography variant="body1">Email {props.patient.email}</Typography>
                </Row>
              </Col>
              <Col xs={12} md={4}>
                <Row>
                  <Typography variant="body1">State {props?.patient?.address?.region}</Typography>
                </Row>
                <Row>
                  <Typography variant="body1">Sex {props?.patient?.gender}</Typography>
                </Row>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={9} lg={9}>
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    placeholder="Type your message here..."
                    rows={10}
                    value={selectedTemplateMessage}
                    onChange={e => setSelectedTemplateMessage(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={3} lg={3}>
                <Card
                  style={{
                    backgroundColor: "#B29EF1"
                  }}
                >
                  <Card.Body>
                    <Card.Title className="text-center">Templates</Card.Title>
                    <Container className="mt-2 mb-2" style={{ width: "100%" }}>
                      <Row>
                        <ButtonGroup />
                      </Row>
                    </Container>
                    <Form.Group className="mt-4">
                      <Form.Control
                        as="select"
                        onChange={e => {
                          setSelectedTemplate({
                            title: e.target.value,
                            id: cmsData?.find(item => item?.name === e.target.value)?.id
                          });
                          setTestType(cmsData?.find(item => item?.name === e.target.value)?.types);
                        }}
                      >
                        <option>Select Template</option>
                        {cmsData?.map((item, index) => {
                          return <option key={index}>{item?.name}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className="mt-2">
                      <Form.Control as="select" onChange={handleChangeTest}>
                        <option>Select Template</option>
                        {testType.map((item, index) => {
                          return <option key={index}>{item?.name}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="modal-footer">
          <button class="btn btn-light" onClick={props.closeSendMsgModal}>
            Cancel
          </button>
          <button
            id="msg_reply"
            class="btn btn-primary"
            onClick={() => {
              submitNotes("external", selectedTemplateMessage, true);
            }}
            disabled={loading}
          >
            Send Message <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </button>
        </Row>
      </Modal.Body>
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </Modal>
  );
};

export default SendResult;
